import type { FaireProductEntity } from "../../entity_types/product";

export const p_ttwxumbcww: FaireProductEntity = {
  token: "p_ttwxumbcww",
  type: "product",
  name: "Kids Suede Patch Beanie (Heather Grey)",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/b3984c020c152be7e86536739022e75f77f0846cd1375df241c3a94219b2d9b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a943dd2c0450a81e029f76b38e0aa36fb257426089a8eb0520d1760a773c7713.jpeg",
    "https://cdn.faire.com/fastly/e5d0bc68462698c625d71df95409e505fe2c3ea434bb1f3f55075ee4244e2d64.jpeg",
  ],
  priceDollars: 5,
  description:
    '✔️GREAT LOOK: Just when you think your child can’t get any cuter, here comes beanies. This thick, knit hat will keep your kid so warm and cuddly, you will want to see your cutie-pie in each color! These beautifully crafted hats will look great on your childs noggin. Great to throw on with everyday outfits and can add pop of style and fun with some cute boots or a winter coat.\n✔️WHEN TO WEAR: Throw this soft hat on your youngster for any chilly outdoor activity. Perfect for a cool, breezy day as well as in the freezing cold winter. Great for the playground, at a pumpkin patch, during Christmas season, in a stroller, at a parade, on a play date, at school or in the best spot…cuddled in your arms. Also makes a great birthday present or stocking stuffer!\n✔️GREAT FIT: One size. Children\'s Hat circumference of 14"-16", ideal for many kids age 1 - 3 years.',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:17.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
